import styles from '../style/styles/ChatInput.module.scss';
import { useChatStateStore } from '../zustand/store';
import { useProductsStore } from '../zustand/store';
import { useSendMessageWithWebSocket, useUserEvent } from '../services/queries/chatbotQueries';
import { sendInputFocusStatus, sendUserSentMessageState, updateVisitHistory } from '../utils/utils';
import { LayoutModeEnum } from '../type/modeState.type';

export const ExamGroup = ({ example, index }) => {
    const { setIsStreaming, setIsChatbotPending } = useChatStateStore();
    const { mutate: sendMessageWithWebSocket } = useSendMessageWithWebSocket();
    const { mutate: sendUserEvent } = useUserEvent();
    const { clearExamples } = useProductsStore();
    const { currentPage, layoutMode, displayLocation } = useChatStateStore();

    return (
        <div
            key={index}
            className={layoutMode === LayoutModeEnum.MODAL ? styles.ChatInput__suggestions__item__small : styles.ChatInput__suggestions__item}
            onMouseDown={(e) => {
                e.stopPropagation();
            }}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <p
                className='h3'
                onMouseDown={(e) => {
                    e.stopPropagation();
                }}
                onClick={(e) => {
                    const gentooStatics = JSON.parse(sessionStorage.getItem('gentoo-statics'));
                    setIsStreaming(true);
                    sendUserSentMessageState(true);
                    sendUserEvent({
                        payload: {
                            ...gentooStatics,
                            timestamp: String(Date.now()),
                            eventCategory: 'chat_input_started',
                            context: {
                                inputType: 'example_click_from_chat',
                                messageText: example,
                                messageLength: example.length,
                            },
                        },
                    });
                    sendMessageWithWebSocket({ messageInput: example, isChatbot: false, preAnswers: [] });
                    setIsChatbotPending(true);
                    sendInputFocusStatus(true);
                    clearExamples();
                    updateVisitHistory(currentPage, displayLocation);
                }}
            >{example}</p>
        </div>
    )
}